import { filterPage } from '@/utils/pageInfo';
export default {
  data () {
    return {
      sortParams: {
        createDate: 'create_date',
        updateDate: 'update_date',
        sumbitDate: 'sumbit_date',
        checkDate: 'check_date',
      },
    }
  },
  methods: {
    onReset () {
      this.$refs.listForm.resetFields();
      this.$refs[`CommonTableRef${this.selectTab}`].clearSort();
      this[`tableParam${this.selectTab}`].orderBy = '';
    },
    toDetail (row) {
      this.$refs[`CommonTableRef${this.selectTab}`].$refs.vxeTable.closeTooltip();
      this.jumpUrl(row, 'detail');
    },
    jumpUrl (row, status, reload, scroll) {
      const { pageName, pageUrl } = filterPage(row.type);
      this.$store.dispatch('tagsView/jumpAndClosePage', {
        open: {
          name: pageName,
          href: `/${pageUrl}?id=${row.id}&status=${status}&productId=${row.productId}&scroll=${scroll}`,
        },
      });
      this.$router.push({
        name: pageUrl,
        params: {
          name: pageName,
          id: row.id,
          row,
          status: status,
        },
        query: { id: row.id, status: status, productId: row.productId, reload: reload, scroll }
      });
    },
    // to样品列表页
    toSamplePage (
      status,
      paramName = 'sample-manage/sample-list',
      name = '样品列表',
    ) {
      this.dialogVisible = false;
      this.$store.dispatch('tagsView/jumpAndClosePage', {
        close: {
          name: this.$route.meta.title,
          href: this.$route.path,
        },
        open: {
          name: name,
          href: `/${paramName}`,
        },
      });
      this.$router.push({
        name: paramName,
        params: {
          status,
          row: this.row,
        },
      });
    },
    // 取消
    createAgain () {
      this.dialogVisible = false;
      this.resetForm();
    },
    // 提交
    submitBtn () {
      this.$refs.formData.validate(valid => {
        valid && this.saveBtn('submit');
      });
    },
    // 审核
    verifyBtn () {
      this.$refs.verifyComponent.$refs.verifyFormData.validate(valid => {
        valid && this.saveBtn();
      });
    },
    filterParam (val) {
      return filterPage(val)
    },
    tabChange () { },
    selectChange (arr) {
      this[`selection${this.selectTab}`] = arr;
    },
    pageSizeChange (pageNo, pageSize) {
      this[`tableParam${this.selectTab}`].pageNo = pageNo;
      this[`tableParam${this.selectTab}`].pageSize = pageSize;
      this.getList();
    },
    sortChange (val) {
      const str = val.split(' ');
      this[`tableParam${this.selectTab}`].orderBy = this.sortParams[str[0]] ? this.sortParams[str[0]] + ' ' + str[1] : val;
      this.getList();
    },
  }
}